/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Hide_PromptInputs */

const en_console_hide_prompt = /** @type {(inputs: Console_Hide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide prompt`)
};

const zh_hans1_console_hide_prompt = /** @type {(inputs: Console_Hide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏提示词`)
};

const pt_br2_console_hide_prompt = /** @type {(inputs: Console_Hide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar prompt`)
};

const es_console_hide_prompt = /** @type {(inputs: Console_Hide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar prompt`)
};

const fr_console_hide_prompt = /** @type {(inputs: Console_Hide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer le prompt`)
};

const de_console_hide_prompt = /** @type {(inputs: Console_Hide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt ausblenden`)
};

const ru_console_hide_prompt = /** @type {(inputs: Console_Hide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть промпт`)
};

const it_console_hide_prompt = /** @type {(inputs: Console_Hide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi prompt`)
};

/**
* | output |
* | --- |
* | "Hide prompt" |
*
* @param {Console_Hide_PromptInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_hide_prompt = /** @type {((inputs?: Console_Hide_PromptInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Hide_PromptInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_hide_prompt(inputs)
	if (locale === "pt-BR") return pt_br2_console_hide_prompt(inputs)
	if (locale === "es") return es_console_hide_prompt(inputs)
	if (locale === "fr") return fr_console_hide_prompt(inputs)
	if (locale === "de") return de_console_hide_prompt(inputs)
	if (locale === "ru") return ru_console_hide_prompt(inputs)
	if (locale === "it") return it_console_hide_prompt(inputs)
	return en_console_hide_prompt(inputs)
});